import { Box, Typography } from '@mui/material';
import { BankTransferInstructions } from '../../interfaces/Checkout/BankTransferInstructions';
import { useLocalizedText } from '../../hooks/useLocalizedText';

type InstructionRowProps = {
  label: string;
  value: string;
};

const InstructionRow = ({ label, value }: InstructionRowProps) => {
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'row', gap: 0.5, width: '100%' }}
    >
      <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
        {label}:
      </Typography>
      <Typography sx={{ fontSize: '14px' }}>{value}</Typography>
    </Box>
  );
};

type BankTransferContentProps = {
  instructions: BankTransferInstructions;
};

export const BankTransferContent = ({
  instructions,
}: BankTransferContentProps) => {
  const t = useLocalizedText();

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, width: '100%' }}
    >
      <InstructionRow
        label={t('checkout.receiver_name')}
        value={instructions.recipientName}
      />
      <InstructionRow label={t('checkout.iban')} value={instructions.iban} />
      <InstructionRow
        label={t('checkout.bank_name')}
        value={instructions.bankName}
      />
      <InstructionRow
        label={t('checkout.bank_branch')}
        value={instructions.branch}
      />
      <InstructionRow
        label={t('checkout.account_number')}
        value={instructions.accountNumber}
      />
    </Box>
  );
};
